import { render, staticRenderFns } from "./excavatorInfo.vue?vue&type=template&id=6b853d53&scoped=true"
import script from "./excavatorInfo.vue?vue&type=script&lang=js"
export * from "./excavatorInfo.vue?vue&type=script&lang=js"
import style0 from "./excavatorInfo.vue?vue&type=style&index=0&id=6b853d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b853d53",
  null
  
)

export default component.exports